import { render, staticRenderFns } from "./JoinChat.vue?vue&type=template&id=22c7ce5b&scoped=true&"
import script from "./JoinChat.vue?vue&type=script&lang=js&"
export * from "./JoinChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7ce5b",
  null
  
)

export default component.exports